import Web3 from "web3";
import FerrumJson from "../../utils/abi/FerrumToken.json";
import ApeRouterJson from "../../utils/abi/ApeRouterAbi.json";
import { Big } from "big.js";
import { AbiItem } from "web3-utils";
// import {
//   cFRMTokenContractAddress,
//   cFRMxTokenContractAddress,
// } from "../../utils/const.utils";
import ApproveRouterJson from "../../utils/abi/ApproveRouterAbi.json";
import {
  arbitrumTestTokenContractAddress,
  cFRMTokenContractAddress,
  cFRMxTokenContractAddress,
  tokenArbTestFrmMainnet,
} from "../../utils/const.utils";
import { getGasFees } from "../../_apis/CompetitionCrud";

const routerConfig = {
  ARBITRUM: "0x1b02dA8Cb0d097eB8D57A175b88c7D8b47997506",
  BSC: "0x10ED43C718714eb63d5aA57B78B54704E256024E",
};
export class Web3Helper {
  web3Client: Web3;

  constructor(web3: Web3) {
    this.web3Client = web3;
  }

  async sendTransactionAsync(
    dispatch: any,
    currency: string,
    transactions: any[],
    payload?: any
  ): Promise<string> {
    const txIds: string[] = [];
    const txs = await this.networkOverrides(transactions, currency)
    for (const tx of txs) {
      const txId = await new Promise<{ [k: string]: string }>(
        (resolve, reject) =>
          this.web3Client.eth
            .sendTransaction({
              from: tx.from,
              to: tx.contract,
              value: tx.value || "0x",
              data: tx.data,
              gas: tx.gas?.gasLimit,
              gasPrice: tx.gas?.gasLimit,
              maxPriorityFeePerGas: tx.gas?.maxPriorityFeePerGas,
              maxFeePerGas: tx.gas?.maxFeePerGas
              // chainId: this.connection.netId()
            })
            // .on("confirmation", function (part1, part2) {
            //   console.log("confirmation", part1, part2);
            // })
            .on("transactionHash", (transactionHash) => {
              //dispatch(transactionHash);
            })
            .then((h: any) => {
              resolve(h);
            })
            .catch(reject)
      );
      // console.log(txId);
      txIds.push(txId.transactionHash);
    }
    // console.log(txIds, "txIdstxIds");
    return txIds.join(",") + "|" + JSON.stringify(payload || "");
  }

  async getTokenData(walletAddress: string, tokenAddr: string) {
    const tokenContract = new this.web3Client.eth.Contract(
      FerrumJson.abi as AbiItem[],
      tokenAddr
    );
    let symbol = await tokenContract.methods.symbol().call();
    let decimals = (await tokenContract.methods.decimals().call()) as any;
    // let name = await tokenContract.methods.name().call();
    let balance = await tokenContract.methods.balanceOf(walletAddress).call();
    const decimalFactor = 10 ** Number(decimals);
    balance = new Big(balance).div(decimalFactor).toFixed();
    return { symbol, decimals, balance };
    // console.log("symbolsymbolsymbol",symbol,balance)
  }

  // async getTokenPriceFromRouter(
  //   currency = "0xaf329a957653675613D0D98f49fc93326AeB36Fc"
  // ) {
  //   try {
  //     const ApeContract = new this.web3Client.eth.Contract(
  //       ApeRouterJson.abi as AbiItem[],
  //       "0x10ED43C718714eb63d5aA57B78B54704E256024E"
  //     );

  //     let pricingRoute = [
  //       currency,
  //       "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
  //       "0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56",
  //       "0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d",
  //     ];
  //     if (currency.toLowerCase() === cFRMxTokenContractAddress.toLowerCase()) {
  //       pricingRoute = [
  //         currency,
  //         "0x8523518001ad5d24b2a04e8729743c0643a316c0",
  //         "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
  //         "0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56",
  //       ];
  //     } else if (
  //       currency.toLowerCase() === cFRMTokenContractAddress.toLowerCase()
  //     ) {
  //       pricingRoute = [
  //         currency,
  //         "0xA719b8aB7EA7AF0DDb4358719a34631bb79d15Dc",
  //         "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
  //         "0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56",
  //       ];
  //     }
  //     const response = await ApeContract.methods
  //       .getAmountsOut("1000000000000000000", pricingRoute)
  //       .call();
  async getTokenPriceFromRouter(
    currency = "0xaf329a957653675613D0D98f49fc93326AeB36Fc",
    network = "BSC"
  ) {
    try {
      const ApeContract = new this.web3Client.eth.Contract(
        ApeRouterJson.abi as AbiItem[],
        //@ts-ignore
        routerConfig[network as any]
      );
      let pricingRoute = [
        currency,
        "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
        "0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56",
        "0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d",
      ];
      if (currency.toLowerCase() === cFRMxTokenContractAddress.toLowerCase()) {
        pricingRoute = [
          currency,
          "0x8523518001ad5d24b2a04e8729743c0643a316c0",
          "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
          "0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56",
        ];
      } else if (
        currency.toLowerCase() === cFRMTokenContractAddress.toLowerCase()
      ) {
        pricingRoute = [
          currency,
          "0xA719b8aB7EA7AF0DDb4358719a34631bb79d15Dc",
          "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
          "0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56",
        ];
      } else if (
        currency.toLowerCase() ===
        arbitrumTestTokenContractAddress.toLowerCase()
      ) {
        pricingRoute = [
          currency,
          "0x9f6AbbF0Ba6B5bfa27f4deb6597CC6Ec20573FDA",
          "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
          "0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8",
        ];
        const response = await ApeContract.methods
          .getAmountsOut("1000000000000000000", pricingRoute)
          .call();
        if (response.length > 0) {
          const res = await this.amountToHuman(
            response[response.length - 1],
            5
          );
          return res;
        }
      } else if (
        currency.toLowerCase() === tokenArbTestFrmMainnet.toLowerCase()
      ) {
        pricingRoute = [
          currency,
          "0x7956Cac1293D5E2F2EC40FA76d7bC299Be01a61f",
          "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
          "0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8",
        ];
        const response = await ApeContract.methods
          .getAmountsOut("1000000000000000000", pricingRoute)
          .call();
        if (response.length > 0) {
          const res = await this.amountToHuman(
            response[response.length - 1],
            5
          );
          return res;
        }
      }

      const response = await ApeContract.methods
        .getAmountsOut("1000000000000000000", pricingRoute)
        .call();
      if (response.length > 0) {
        return await this.amountToHuman(response[response.length - 1], 18);
      }
      return 0;
    } catch (e) {
      // console.log(e)
    }
  }

  async getExchangeTokenFromRouter(
    firstToken: any,
    secondToken: any,
    network: string = "BSC"
  ) {
    try {
      // const ApeContract = new this.web3Client.eth.Contract(
      //   ApeRouterJson.abi as AbiItem[],
      //   "0x10ED43C718714eb63d5aA57B78B54704E256024E"
      // );

      // let pricingRoute = [firstToken, secondToken];
      // const response = await ApeContract.methods
      //   .getAmountsOut("1000000000000000000", pricingRoute)
      //   .call();
      const ApeContract = new this.web3Client.eth.Contract(
        ApeRouterJson.abi as AbiItem[],
        //@ts-ignore
        routerConfig[network as any]
      );

      let pricingRoute = [firstToken, secondToken];
      const response = await ApeContract.methods
        .getAmountsOut("1000000000000000000", pricingRoute)
        .call();
      if (response.length > 0) {
        return await this.amountToHuman(response[response.length - 1], 18);
      }
      return 0;
    } catch (e) {
      // console.log(e)
    }
  }

  async amountToHuman(amount: string, decimal: number) {
    const decimalFactor = 10 ** decimal;
    return new Big(amount).div(decimalFactor).toFixed();
  }

  weiToEther(wei: any) {
    return Web3.utils.fromWei(String(wei), "ether");
  }

  async allowanceMethod(
    tokenContractAddress: any,
    walletAddress: any,
    fiberRouterSmartContractAddress: any
  ) {
    try {
      const stateVariable = new this.web3Client.eth.Contract(
        ApproveRouterJson.abi as AbiItem[],
        tokenContractAddress
      );
      const response = await stateVariable.methods
        .allowance(walletAddress, fiberRouterSmartContractAddress)
        .call();
      return response;
    } catch (e) {
      console.log("allowanceMethod", e);
    }
  }

  async tokenDecimals(tokenContractAddress: any) {
    try {
      const stateVariable = new this.web3Client.eth.Contract(
        ApproveRouterJson.abi as AbiItem[],
        tokenContractAddress
      );
      const response = await stateVariable.methods.decimals().call();
      return response;
    } catch (e) {
      console.log("allowanceMethod", e);
    }
  }

  async approveMethod(
    sourceChainId: string,
    tokenContractAddress: any,
    walletAddress: any,
    fiberRouterSmartContractAddress: any
  ) {
    try {
      let fixedAllocation =
        "115792089237316195423570985008687907853269984665640564039457584007913129639935";
      const stateVariable = new this.web3Client.eth.Contract(
        ApproveRouterJson.abi as AbiItem[],
        tokenContractAddress
      );
      if (sourceChainId === "137") {
        let gas = await this.web3Client.eth.estimateGas({
          from: walletAddress,
        });
        gas = 60000 + gas;
        let gasPrice = await this.web3Client.eth.getGasPrice();
        gasPrice = new Big(gasPrice).mul(1.5).round().toString();
        const response = await stateVariable.methods
          .approve(fiberRouterSmartContractAddress, fixedAllocation)
          .send({ from: walletAddress, gas, gasPrice })
          .on("sent", async () => {});
        return response;
      } else {
        const response = await stateVariable.methods
          .approve(fiberRouterSmartContractAddress, fixedAllocation)
          .send({ from: walletAddress })
          .on("sent", async () => {});
        return response;
      }
    } catch (e) {
      console.log("approveMethod", e);
    }
  }

  async sendSwapTransactionAsync(payload: any) {
    //, isCudosCompatible: any
    console.log(payload);
    return new Promise((resolve, reject) => {
      this.web3Client.eth
        .sendTransaction(payload)
        .on("transactionHash", (transactionHash) => {
          console.log("transactionHash", transactionHash);
          if (transactionHash) {
            console.log(transactionHash);
            resolve(transactionHash);
          }
        })
        .on("receipt", (receipt) => {
          if (receipt.transactionHash) {
            console.log("receipt", receipt);
          }
        })
        .then((data: any) => {
          if (data && data.transactionHash) {
            console.log("swap completed::", data);
          }
        })
        .catch((e: any) => {
          console.log("failed", e);
          reject(e);
        });
    });
  }

  private networkOverrides = async (transactions: any[], currency?: string) => {
    let networks = {
      "ETHEREUM_ARBITRUM": {
          maxFeePerGas: 200000000,
          maxPriorityFeePerGas: 100000000,
          gas: 3500000000,
          gasLimit: 4000000
      },
      "BSC": {
          maxFeePerGas: 3500000000,
          maxPriorityFeePerGas: 3500000000,
          gas: 3500000000,
          gasLimit: 2000000
      }
    }

    const networksMap = {
      "ETHEREUM_ARBITRUM": 42161,
      "BSC": 56,
      "ETHEREUM": 1,
      "POLYGON_MAINNET": 137,
      "POLYGON": 137,
      "AVAX_MAINNET": 43114,
      "AVAX": 43114,
  }

    const res = await Promise.all(transactions.map(
      async (e: any) => {
          const txType = (e?.description && (e?.data.startsWith('0x095ea7b')) ? 'approval' : 'general');
          const network = (e.currency.split(':') || [])[0]
          const chainId = networksMap[network as keyof typeof networksMap]
          //@ts-ignore
          const gasOverride = networks[network as any]
          let gasRes = await getGasFees(chainId, null, txType)
          if (chainId && gasRes.status === 200 && gasRes?.data?.body?.gasFees) {
              const gasFee = {
                  gas: gasRes?.data?.body?.gasFees?.gasLimit,
                  gasLimit: Number(gasRes?.data?.body?.gasFees?.gasLimit),
                  maxFeePerGas: Number(gasRes?.data?.body?.gasFees?.maxFeePerGas) * 1000000000,
                  maxPriorityFeePerGas: Number(gasRes?.data?.body?.gasFees?.maxPriorityFeePerGas) * 1000000000,
              }
              e.gas = gasFee;
              return e
          }else {
              if(network && gasOverride) {
                  e.gas = gasOverride
                  return e
              }else {
                  return e
              }
          }               
      }
  ))
  console.log(res, 'gasresponse')
  return res
}

  async checkTransactionReceipt(txId: any) {
    try {
      const receipt = await this.web3Client.eth.getTransactionReceipt(txId);
      return receipt;
    } catch (e) {
      console.log("checkTransactionStatus", e);
    }

    return null;
  }
}
